import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, Input, Button, Table, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import { toast } from "react-toastify";
import "boxicons/css/boxicons.min.css";
import { formatIST } from "../../Helpers/Utils";

const CategoryList = () => {

    const dispatch = useDispatch();

    const [rows, setRows] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const limit = 10;
    const loading = useSelector(state => state.loading.loading);

    /* MODAL */
    const [open, setOpen] = useState(false);
    const [name, setName] = useState("");
    const [editId, setEditId] = useState(null);

    const load = async (p = page, q = search) => {
        dispatch(loadingTrue());
        const res = await Handler({
            method: "get",
            url: `/categories/list.php?page=${p}&limit=${limit}&search=${q}`
        });

        if (res?.success) {
            setRows(res.data?.categories || []);
            setTotal(res.data?.pagination?.total || 0);
        } else toast.error(res?.message || "Failed to load categories");

        dispatch(loadingFalse());
    };

    useEffect(() => { load(1, search); }, [search]);
    useEffect(() => { load(page, search); }, [page]);

    /* OPEN ADD */
    const openAdd = () => {
        setEditId(null);
        setName("");
        setOpen(true);
    };

    /* OPEN EDIT */
    const openEdit = (row) => {
        setEditId(row.id);
        setName(row.name);
        setOpen(true);
    };

    /* SAVE (ADD / EDIT) */
    const save = async () => {
        if (!name.trim()) return toast.error("Category name required");

        dispatch(loadingTrue());

        const res = editId
            ? await Handler({
                method: "patch",
                url: "/categories/update.php",
                data: { id: editId, name }
            })
            : await Handler({
                method: "post",
                url: "/categories/create.php",
                data: { name }
            });

        if (res?.success) {
            toast.success(editId ? "Category updated" : "Category added");
            setOpen(false);
            setEditId(null);
            setName("");
            load(1, "");
        } else toast.error(res?.message || "Save failed");

        dispatch(loadingFalse());
    };

    return (
        <>
            {/* HEADER */}
            <Row className="mb-3 align-items-center">
                <Col md={6}>
                    <h5 className="fw-bold mb-0">Categories</h5>
                    <small className="text-muted">Manage product categories</small>
                </Col>
                <Col md={6} className="text-end">
                    <Button disabled={loading} className="list-add-btn d-inline-flex align-items-center gap-1" onClick={openAdd}>
                        <i className="bx bx-plus"></i> Add Category
                    </Button>
                </Col>
            </Row>

            {/* SEARCH */}
            <Card className="mb-3">
                <CardBody>
                    <Input
                        placeholder="Search category..."
                        value={search}
                        onChange={e => { setSearch(e.target.value); setPage(1); }}
                    />
                </CardBody>
            </Card>

            {/* TABLE */}
            <Card>
                <CardBody>
                    <Table responsive borderless className="modern-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Category Name</th>
                                <th>Created</th>
                                <th className="text-end">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length ? rows.map((c, i) => (
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td className="fw-semibold">{c.name}</td>
                                    <td>
                                        {/* {new Date(c.created_at).toLocaleDateString()} */}
                                        {formatIST(c?.created_at)}
                                    </td>
                                    <td className="text-end">
                                        <Button disabled={loading} size="sm" color="light" onClick={() => openEdit(c)}>
                                            <i className="bx bx-edit"></i>
                                        </Button>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="3" className="text-center text-muted">No categories found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    <Pagination
                        page={page}
                        total={total}
                        limit={limit}
                        onPrev={() => setPage(p => Math.max(1, p - 1))}
                        onNext={() => setPage(p => p + 1)}
                    />
                </CardBody>
            </Card>

            {/* ADD / EDIT MODAL */}
            <Modal isOpen={open} toggle={() => setOpen(false)} centered>
                <ModalHeader toggle={() => setOpen(false)}>
                    {editId ? "Edit Category" : "Add Category"}
                </ModalHeader>
                <ModalBody>
                    <label className="form-label">Category Name *</label>
                    <Input
                        value={name}
                        placeholder="Enter category name"
                        onChange={e => setName(e.target.value)}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button disabled={loading} color="light" onClick={() => setOpen(false)}>Cancel</Button>
                    <Button disabled={loading} color="success" onClick={save}>
                        <i className="bx bx-check"></i> Save
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default CategoryList;
